import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LifeCycleModule } from '@portal-core/general/directives/life-cycle/life-cycle.module';
import { EditorToolbarItemModule } from '@portal-core/ui/editor/directives/editor-toolbar-item/editor-toolbar-item.module';
import { EditorToolbarComponent } from './editor-toolbar.component';

@NgModule({
  declarations: [
    EditorToolbarComponent
  ],
  imports: [
    CommonModule,
    LifeCycleModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatTooltipModule,
    EditorToolbarItemModule
  ],
  exports: [
    EditorToolbarComponent,
    EditorToolbarItemModule
  ]
})
export class EditorToolbarModule { }
